export default __webpack_public_path__ + "static/media/logo_governanca_light.22bb8fc7.png";